import { render } from "./AssignmentPriceGroup.vue?vue&type=template&id=1a11fd53&ts=true"
import script from "./AssignmentPriceGroup.vue?vue&type=script&lang=ts"
export * from "./AssignmentPriceGroup.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__